<svg
  id="e3dzF0I8RBr1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="1190.62755 580.24151 690.49644 494.80542"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  project-id="5727c7c513224332b363bc1876ca54a6"
  export-id="2e9c9ed48c92472f887d2c2b029e9223"
  cached="false"
>
  <g transform="translate(-.000013 0)">
    <path
      d="M1239.85077,797.17148c-31.49878,53.33203-48.83748,110.78066-49.22322,166.30096c14.96508-38.17178,37.41851-65.74619,64.51754-84.33921c33.37164-76.71872,96.83183-156.70991,166.98008-199.07452c163.55342-98.7761,352.49124-38.18892,383.42434,110.01334c29.55878,20.92676,54.63851,46.06836,73.76773,74.60766c26.73038-245.73419-248.31933-365.22767-481.86599-224.18197l-.00126.00214c-68.01069,41.07311-121.89846,96.22889-157.59814,156.67221l-.00108-.00061Z"
      transform="translate(.934603-.349826)"
      fill="#292f33"
      stroke-miterlimit="10"
    />
    <path
      d="M1606.45494,838.59905c49.44961,41.52865,67.22048,114.42732,32.73844,175.71051c9.48587,19.47958,15.65241,39.87826,17.67224,60.73737c49.90374-69.02666,41.06402-154.38612-5.50913-212.27304-13.93788-9.13377-28.96656-17.25591-44.90156-24.17483Zm70.46319-75.40868c55.31571,36.21932,84.7164,99.7586,76.89993,167.22864c19.69653,23.56727,34.89167,49.48421,44.48365,76.90244c20.17533-56.47138,18.46694-113.54077-.95963-162.63175-29.2905-36.31381-71.27223-64.53222-120.42396-81.49933Z"
      transform="translate(.472541-.349826)"
      fill="#292f33"
      stroke-miterlimit="10"
    />
    <path
      d="M1312.45823,828.77904c-27.9797,48.77675-43.16354,107.53062-37.98834,174.97933c35.98327-163.23927,309.34471-136.89937,341.69242-11.84235c42.75576-98.58667-40.72791-175.91357-130.95936-188.56645c111.19693-11.0014,204.36035,37.44116,236.04295,85.25615c1.29115-45.28732-56.39467-137.54209-145.11127-161.53083c69.88852-8.25413,135.24073,13.23104,199.61336,65.60243-46.84795-193.07189-353.52574-155.25245-463.29149,36.10214l.00173-.00042Z"
      transform="translate(.010478-.349826)"
      fill="#66757f"
      stroke-miterlimit="10"
    />
  </g>
  <path d="" fill="none" stroke="#3f5787" stroke-width="1.380993" />
</svg>
